module.exports = __webpack_public_path__ + "img/product3.5c303d4d.png";